export const CUSTOM_GRID_TEST_ID = "generic-custom-grid";
export const TOOLTIP_DELAY_TIME = 100;
export const CUSTOM_GRID_ROW_HEIGHT = 44;
export const CUSTOM_GRID_HEADER_HEIGHT = 44;
export const CUSTOM_GRID_REORDER_COL_ID = "reorder";
export const GENERIC_CUSTOM_FIELD_MODAL_WIDTH = "800px";
export const GENERIC_CUSTOM_FIELD_MODAL_HEIGHT = "600px";
export const GENERIC_CUSTOM_FIELD_DATA_GRID_CONTAINER_WIDTH = 766;

export const ASSOCIATION_ENTITY_COLLECTION_KEYS = {
  TRANSCRIPT_ACADEMIC_YEARS: "TRANSCRIPT_ACADEMIC_YEARS",
  TRANSCRIPT_COURSES: "TRANSCRIPT_COURSES",
  TRANSCRIPT_GRADE_SCALES: "TRANSCRIPT_GRADE_SCALES",
  TRANSCRIPT_GRADES: "TRANSCRIPT_GRADES",
  TRANSCRIPT_GRADING_PERIODS: "TRANSCRIPT_GRADING_PERIODS",
  TRANSCRIPT_LEVELS: "TRANSCRIPT_LEVELS",
  TRANSCRIPT_SCHOOLS: "TRANSCRIPT_SCHOOLS",
};
